<template>
  <v-col cols="12">
    <v-card tile class="mx-1">
      <v-card-title>
        <p>Prestação de Contas Financeira</p> 
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="mb-n4">
            <span class="font-weight-bold text-uppercase">Projeto:</span>
            <p class="font-weight-light title ">
              {{ prestacaoConta.projeto.titulo }}
            </p>
          </v-col>

          <v-col cols="4" class="mb-n4">
            <span class="font-weight-bold text-uppercase">Parceiro:</span>
            <p class="font-weight-light title">
              {{ prestacaoConta.organizacao.nome }}
            </p>
          </v-col>
          <v-col cols="4" class="mb-n4">
            <span class="font-weight-bold text-uppercase">Responsável:</span>
            <p class="font-weight-light title ">
              {{ prestacaoConta.responsavel.nome }}
            </p>
          </v-col>
          <v-col cols="4" class="mb-n4">
            <span class="font-weight-bold text-uppercase">E-mail:</span>
            <p class="font-weight-light title ">
              {{ prestacaoConta.responsavel.email }}
            </p>
          </v-col>
          <v-col cols="4" class="mb-n4">
            <span class="font-weight-bold text-uppercase">Período da Prestação de Contas:</span>
            <p class="font-weight-light title ">
              {{ prestacaoConta.periodo }}
            </p>
          </v-col>

          <v-col cols="4" class="mb-n4">
            <span class="font-weight-bold text-uppercase">Data:</span>
            <p class="font-weight-light title">
              {{ formatDate(prestacaoConta.data) }}
            </p>
          </v-col>

          <v-col cols="12">
            <span class="font-weight-bold text-uppercase">Check list de itens apresentados:</span>
            <v-checkbox
              class="mb-n6"
              v-model="prestacaoConta.relatorioDespesa"
              label="Relátorio de Despesas"
              readonly
            ></v-checkbox>
            <v-checkbox
              class="mb-n6"
              v-model="prestacaoConta.extratoContaCorrenteInvestimento"
              label="Extrato de Conta Corrente e Investimentos"
              readonly
            ></v-checkbox>
            <v-checkbox
              class="mb-n6"
              v-model="prestacaoConta.documentoComprovanteDespesa"
              label="Documentos Comprovantes de Despesas"
              readonly
            ></v-checkbox>
            <v-checkbox
              class="mb-n6"
              v-model="prestacaoConta.folhaDedicacaoPessoal"
              label="Folha de Dedicação de Pessoal"
              readonly
            ></v-checkbox>
            <v-checkbox
              class="mb-n6"
              v-model="prestacaoConta.frequenciaPessoalProjeto"
              label="Frequência Pessoal Projeto"
              readonly
            ></v-checkbox>
            <v-checkbox
              class="mb-n6"
              v-model="prestacaoConta.inventario"
              label="Inventário"
              readonly
            ></v-checkbox>
            <v-checkbox
              class="mb-n4"
              v-model="prestacaoConta.contabilidade"
              label="Contabilidade"
              readonly
            ></v-checkbox>
            <v-checkbox
              class="mb-n4"
              v-model="prestacaoConta.outros"
              label="Outros"
              readonly
            ></v-checkbox>
            <p v-if="prestacaoConta.outros" class="font-weight-light title ">
              {{ prestacaoConta.outrosItens }}
            </p>
          </v-col>
          <v-col cols="12" class="mb-n4 mt-n6">
            <span class="font-weight-bold text-uppercase">Link:</span>
            <p class="font-weight-light title ">
              {{ prestacaoConta.links }}
            </p>
          </v-col>
          <v-col cols="12" class="mb-n4">
            <span class="font-weight-bold text-uppercase">Observações:</span>
            <p class="font-weight-light title ">
              {{ prestacaoConta.observacoes }}
            </p>
          </v-col>
            <v-list class="ml-2" v-if="prestacaoConta.arquivoPrestacao">
              <v-list-item link>
                  <v-list-item-content class="py-2">
                    <v-list-item-title>{{prestacaoConta.arquivoPrestacao.name}}</v-list-item-title>
                  </v-list-item-content>
                <v-list-item-action-text>
                  <v-btn @click="downloadItem()" class="ml-6" outlined color="primary">
                    Download <v-icon color="primary lighten-1">mdi-arrow-down-bold-circle-outline</v-icon>
                  </v-btn>
                </v-list-item-action-text>
              </v-list-item>
            </v-list>
        </v-row>
      </v-card-text>

      <v-divider v-if="hasPermissionEdit"></v-divider>

      <v-card-actions v-if="hasPermissionEdit" class="mx-1">
        <Confirm ref="confirm"></Confirm>
        <EditaPrestacaoContas :prestacaoConta="prestacaoConta"></EditaPrestacaoContas>
        <v-btn color="error text-center" @click="excluir" small>Excluir</v-btn>
        <v-btn @click="enviar()" color="info" small>Enviar para monitoramento</v-btn>
      </v-card-actions>

      <v-divider v-if="hasPermissionDeleteReabrir"></v-divider>

      <v-card-actions v-if="hasPermissionDeleteReabrir" class="mx-1">
        <Confirm ref="confirm"></Confirm>
        <v-btn @click="excluir" color="error text-center" class="mb-2" small>Excluir</v-btn>
        <v-btn @click="reabrir()" color="warning" class="mb-2" small>Reabrir Prestação de Contas</v-btn>
      </v-card-actions>

    </v-card>

    <Confirm ref="confirm"></Confirm>

  </v-col>

</template>

<script>
import { mapActions } from "vuex";
import EditaPrestacaoContas from "./Edita/EditaPrestacaoContas"
import Confirm from "@/components/Dialog/Confirm";

export default {
  components: {
    EditaPrestacaoContas,
    Confirm
  },
  props: {
    prestacaoConta: {
      type: Object,
      required: true,
    },
    papeis: {
      required: true,
    },
  },  
  computed: {
    usuario() {
      return this.$store.getters["usuario/getUser"]
    },

    papeisList() {
      var payload = {
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.$store.getters["usuario/getUsuarioAutenticado"].id,
      }      
      return this.$store.getters["projeto/getPapeisParticipante"](payload);
    },

    hasPermissionEdit() {
      var payload = {
        'prestacaoContaId': parseInt(this.$route.params.prestacaoContaId),
        'papeis': this.papeisList,
        'permission': 'PERMISSION_PRESTACAO_CONTAS_EDIT'
      }     
      return this.$store.getters["prestacaoConta/hasPermission"](payload)      
    },

    hasPermissionDeleteReabrir() {
      var payload = {
        'prestacaoContaId': parseInt(this.$route.params.prestacaoContaId),
        'papeis': this.papeisList,
        'permission': 'PERMISSION_PRESTACAO_CONTAS_DELETE_ABERTURA'
      }     
      return this.$store.getters["prestacaoConta/hasPermission"](payload)      
    },
  },

  data() {
    return {
    };
  },
  methods: {
    ...mapActions("prestacaoConta", ["proximaEtapa", "downloadArquivo", "excluirPrestacaoConta", "reaberturaPrestacaoConta"]),

    formatDate(data) {
      if (!data) return null

      const [ano, mes, dia] = data.split('-')
      return `${dia}/${mes}/${ano}`
    }, 
    getPayload(){
       return {
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.usuario.id
      }     
    },
    enviar() {
      var payload = {
        projetoId: this.$route.params.projetoId, 
        prestacaoContaId: this.$route.params.prestacaoContaId,
        enviarPara: 'enviar-monitoramento'
      }

      this.proximaEtapa(payload)
    },
    downloadItem() {
      const payload = {
        "projetoId": this.prestacaoConta.projeto.id,
        'arquivoId': this.prestacaoConta.arquivoPrestacao.id
      }

      console.log(payload)
      this.downloadArquivo(payload)
    },

    excluir() {
      this.$refs.confirm
        .open(
          'Excluir Prestação de Conta',
          '',
          "Você tem certeza?",
          {}
        )
        .then((confirm) => {
          if (confirm) {
            let payload = {
              projetoId: this.$route.params.projetoId, 
              prestacaoContaId: this.$route.params.prestacaoContaId
            }
            this.excluirPrestacaoConta(payload)
              .then(() => {
                this.$router.push({ name: 'Contas', params: {projetoId: this.$route.params.projetoId} })
              });
          }
        });
    },

    reabrir() {
      this.$refs.confirm
        .open(
          'Reabrir Prestação de Conta',
          '',
          "Você tem certeza?",
          {}
        )
        .then((confirm) => {
          if (confirm) {
            var payload = {
              projetoId: this.$route.params.projetoId, 
              prestacaoContaId: this.$route.params.prestacaoContaId,
              enviarPara: 'reabrir-monitoramento'
            }
            
            this.reaberturaPrestacaoConta(payload)
              .then(() => {
                this.$router.push({ name: 'Contas', params: {projetoId: this.$route.params.projetoId} })
              });
          }
        });
    },


  },
  created() {
  },
};
</script>

